// Event delegation — survives Kentico page builder widget AJAX re-renders.
// When a toggle marked [data-wf-collapse-toggle-prevent-close="true"] is clicked
// and the target collapse is already open, keep it open instead of toggling it closed.
document.addEventListener('click', (event) => {
  const elem = (event.target as HTMLElement).closest<HTMLElement>(
    '[data-wf-collapse-toggle-prevent-close="true"]'
  );
  if (!elem) return;
  const collapseElementId = elem.getAttribute('data-bs-target') || elem.getAttribute('href');
  if (collapseElementId) {
    const collapseElement = document.querySelector<HTMLElement>(collapseElementId);
    if (collapseElement) {
      elem.classList.remove('collapsed');
      collapseElement.classList.add('show');
    }
  }
});
